export const iconFontAwesomeAlphabetU = (
	<i className="fa-solid fa-u"></i>
);
